import React from 'react'

import { FULFILLED, PRODUCT_PAGE } from '../../../constants/constants'
import { setIsSummaryPanelVisible } from '../../../store/ui/uiSlice'

import AddToCart from './AddToCart'

import * as commonStyles from '../styles'
import * as styles from './styles'
import { useAppDispatch, useAppSelector } from '../../../hooks'

const Styled = {
  ...commonStyles,
  ...styles,
}

interface Props {
  onRequestSaveProject: (args: { type: string }) => {
    internalSaveUuidv4: string | null
  }
  buttonText: string
}

const ProceedButton: React.FC<Props> = ({ onRequestSaveProject }) => {
  const dispatch = useAppDispatch()
  const { applicationMode, content } = useAppSelector((state) => state.init)
  const {
    requestStatus: { requestStatus_fetchPrices_aggregated },
  } = useAppSelector((state) => state.requests)
  const { isSummaryPanelVisible } = useAppSelector((state) => state.ui)

  if (applicationMode === 'product-page' || isSummaryPanelVisible) {
    return <AddToCart onRequestSaveProject={onRequestSaveProject} />
  }

  return (
    // @ts-expect-error // TODO
    <Styled.CTA
      applicationMode={applicationMode}
      // Adding className to apply Scensum styling
      className={`button-primary${applicationMode === PRODUCT_PAGE ? '-large' : ''}`}
      disabled={requestStatus_fetchPrices_aggregated !== FULFILLED}
      onClick={() => dispatch(setIsSummaryPanelVisible(true))}
    >
      {content.buttons.next}
    </Styled.CTA>
  )
}

export default ProceedButton
